import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/remote-config";
import _ from "lodash";

const isDevServer = !(
  _.includes(window.location.href, "https://m.flybit.com") ||
  _.includes(window.location.href, "https://m.v1.flybit.com") ||
  _.includes(window.location.href, "https://m.stg.flybit.com")
);

const firebaseInit = {
  apiKey: "AIzaSyBaI1G5nyACrA9eSZLx3F4iRRmJjRSQkSs",
  authDomain: "flybitandroid.firebaseapp.com",
  databaseURL: isDevServer
    ? "https://third.dev.flybit.com/remote"
    : "https://flybit.com",
  projectId: "flybitandroid",
  storageBucket: "flybitandroid.appspot.com",
  messagingSenderId: "489367149795",
  appId: "1:489367149795:web:509ace3ec533e25e8c79d6",
  measurementId: "G-ZDDVTEG229",
};

// Initialize Firebase
// firebase.initializeApp(firebaseInit);
// const analytics = firebase.analytics();

const firebaseCustomEvent = (eventKey, eventValue) => {
  if (isDevServer) {
    return;
  } else {
    analytics.logEvent(eventKey, eventValue);
  }
};

// const getRemoteConfig = firebase.remoteConfig();

// if (isDevServer) {
//   getRemoteConfig.settings.minimumFetchIntervalMillis = 0;
// } else {
//   getRemoteConfig.settings.minimumFetchIntervalMillis = 360000;
// }

export { firebaseCustomEvent };
